// extracted by mini-css-extract-plugin
export var previewContainer = "_sy-0";